"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Action2 = _interopRequireDefault(require("./Action"));
var _BlotFormatter = _interopRequireDefault(require("../BlotFormatter"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var ResizeAction = /*#__PURE__*/function (_Action) {
  _inherits(ResizeAction, _Action);
  var _super = _createSuper(ResizeAction);
  function ResizeAction(formatter) {
    var _this;
    _classCallCheck(this, ResizeAction);
    _this = _super.call(this, formatter);
    _defineProperty(_assertThisInitialized(_this), "topLeftHandle", void 0);
    _defineProperty(_assertThisInitialized(_this), "topRightHandle", void 0);
    _defineProperty(_assertThisInitialized(_this), "bottomRightHandle", void 0);
    _defineProperty(_assertThisInitialized(_this), "bottomLeftHandle", void 0);
    _defineProperty(_assertThisInitialized(_this), "dragHandle", void 0);
    _defineProperty(_assertThisInitialized(_this), "dragStartX", void 0);
    _defineProperty(_assertThisInitialized(_this), "preDragWidth", void 0);
    _defineProperty(_assertThisInitialized(_this), "targetRatio", void 0);
    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      if (!(event.target instanceof HTMLElement)) {
        return;
      }
      _this.dragHandle = event.target;
      _this.setCursor(_this.dragHandle.style.cursor);
      if (!_this.formatter.currentSpec) {
        return;
      }
      var target = _this.formatter.currentSpec.getTargetElement();
      if (!target) {
        return;
      }
      var rect = target.getBoundingClientRect();
      _this.dragStartX = event.clientX;
      _this.preDragWidth = rect.width;
      _this.targetRatio = rect.height / rect.width;
      document.addEventListener('pointermove', _this.onDrag);
      document.addEventListener('pointerup', _this.onMouseUp);
    });
    _defineProperty(_assertThisInitialized(_this), "onDrag", function (event) {
      if (!_this.formatter.currentSpec) {
        return;
      }
      var target = _this.formatter.currentSpec.getTargetElement();
      if (!target) {
        return;
      }
      var deltaX = event.clientX - _this.dragStartX;
      var newWidth = 0;
      if (_this.dragHandle === _this.topLeftHandle || _this.dragHandle === _this.bottomLeftHandle) {
        newWidth = Math.round(_this.preDragWidth - deltaX);
      } else {
        newWidth = Math.round(_this.preDragWidth + deltaX);
      }
      var newHeight = _this.targetRatio * newWidth;
      target.setAttribute('width', "".concat(newWidth));
      target.setAttribute('height', "".concat(newHeight));
      _this.formatter.update();
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function () {
      _this.setCursor('');
      document.removeEventListener('pointermove', _this.onDrag);
      document.removeEventListener('pointerup', _this.onMouseUp);
    });
    _this.topLeftHandle = _this.createHandle('top-left', 'nwse-resize');
    _this.topRightHandle = _this.createHandle('top-right', 'nesw-resize');
    _this.bottomRightHandle = _this.createHandle('bottom-right', 'nwse-resize');
    _this.bottomLeftHandle = _this.createHandle('bottom-left', 'nesw-resize');
    _this.dragHandle = null;
    _this.dragStartX = 0;
    _this.preDragWidth = 0;
    _this.targetRatio = 0;
    return _this;
  }
  _createClass(ResizeAction, [{
    key: "onCreate",
    value: function onCreate() {
      this.formatter.overlay.appendChild(this.topLeftHandle);
      this.formatter.overlay.appendChild(this.topRightHandle);
      this.formatter.overlay.appendChild(this.bottomRightHandle);
      this.formatter.overlay.appendChild(this.bottomLeftHandle);
      this.repositionHandles(this.formatter.options.resize.handleStyle);
    }
  }, {
    key: "onDestroy",
    value: function onDestroy() {
      this.setCursor('');
      this.formatter.overlay.removeChild(this.topLeftHandle);
      this.formatter.overlay.removeChild(this.topRightHandle);
      this.formatter.overlay.removeChild(this.bottomRightHandle);
      this.formatter.overlay.removeChild(this.bottomLeftHandle);
    }
  }, {
    key: "createHandle",
    value: function createHandle(position, cursor) {
      var box = document.createElement('div');
      box.classList.add(this.formatter.options.resize.handleClassName);
      box.setAttribute('data-position', position);
      box.style.cursor = cursor;
      if (this.formatter.options.resize.handleStyle) {
        Object.assign(box.style, this.formatter.options.resize.handleStyle);
      }
      box.addEventListener('dragstart', function () {
        return false;
      });
      box.addEventListener('pointerdown', this.onMouseDown, false);
      return box;
    }
  }, {
    key: "repositionHandles",
    value: function repositionHandles(handleStyle) {
      var handleXOffset = '0px';
      var handleYOffset = '0px';
      if (handleStyle) {
        if (handleStyle.width) {
          handleXOffset = "".concat(-parseFloat(handleStyle.width) / 2, "px");
        }
        if (handleStyle.height) {
          handleYOffset = "".concat(-parseFloat(handleStyle.height) / 2, "px");
        }
      }
      Object.assign(this.topLeftHandle.style, {
        left: handleXOffset,
        top: handleYOffset
      });
      Object.assign(this.topRightHandle.style, {
        right: handleXOffset,
        top: handleYOffset
      });
      Object.assign(this.bottomRightHandle.style, {
        right: handleXOffset,
        bottom: handleYOffset
      });
      Object.assign(this.bottomLeftHandle.style, {
        left: handleXOffset,
        bottom: handleYOffset
      });
    }
  }, {
    key: "setCursor",
    value: function setCursor(value) {
      if (document.body) {
        document.body.style.cursor = value;
      }
      if (this.formatter.currentSpec) {
        var target = this.formatter.currentSpec.getOverlayElement();
        if (target) {
          target.style.cursor = value;
        }
      }
    }
  }]);
  return ResizeAction;
}(_Action2["default"]);
exports["default"] = ResizeAction;